import { useInfiniteQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { prettyDate } from '@/helpers/utils';
import { streakService } from '../../services/streakService';

export const useGetStreakActivityInfinity = () => {
  return useInfiniteQuery({
    refetchOnWindowFocus: false,
    queryKey: [QUERY_KEYS.streak.activity_infinity],
    queryFn: ({ pageParam = 1 }) =>
      streakService.activity({ page: pageParam, limit: 10 }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return {
            ...data,
            grouped: data.list.reduce((acc, item) => {
              const year = prettyDate(item.round_date, 'YYYY');
              acc[year] ? acc[year].push(item) : (acc[year] = [item]);
              return acc;
            }, {}),
          };
        }
        throw new Error('Fetch failed');
      }),
    getNextPageParam: (lastPage, allPages) => {
      const maxPage = lastPage?.total_pages || 0;
      const nextPage = allPages.length + 1;
      return nextPage <= maxPage ? nextPage : undefined;
    },
  });
};
